import { render, staticRenderFns } from "./etapa_10.vue?vue&type=template&id=26e85eb8&scoped=true&"
import script from "./etapa_10.vue?vue&type=script&lang=js&"
export * from "./etapa_10.vue?vue&type=script&lang=js&"
import style0 from "./etapa_10.vue?vue&type=style&index=0&id=26e85eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e85eb8",
  null
  
)

export default component.exports